import { isNil } from '@flowio/is';
/**
 * Appends the parameters to the given url.
 * The base url can contain existing query parameters.
 * @param url The base url.
 * @param parameters The parameters to add.
 * @return A new valid url with the parameters appended.
 */

export default function appendQueryParameters(url, parameters) {
  var hashIndex = url.indexOf('#');
  var hash = hashIndex !== -1 ? url.substring(hashIndex) : '';
  var base = hashIndex !== -1 ? url.substring(0, hashIndex) : url;
  var pairs = [];
  Object.keys(parameters).forEach(function (key) {
    var value = parameters[key];

    if (!isNil(value)) {
      pairs.push("".concat(key, "=").concat(encodeURIComponent(value)));
    }
  });
  return [base, url.indexOf('?') === -1 ? '?' : '&', pairs.join('&'), hash].join('');
}


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/postmessage/lib/esm/appendQueryParameters.js
// module id = 647
// module chunks = 0 1